import { useEffect, useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { NotesTextEditorHandle, Tabs } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { MeetingNotes } from 'modules/meetings/components/MeetingNotes'
import { MeetingSkeleton } from 'modules/meetings/components/Skeletons/MeetingSkeleton'
import { useMeeting } from 'modules/meetings/lib/hooks/useMeeting'
import { useMeetingTranscript } from 'modules/meetings/lib/hooks/useMeetingTranscript'
import { MeetingState } from 'modules/meetings/lib/hooks/useNotesTextEditorConfig'

import { PostMeetingTranscript } from './components/PostMeetingTranscript'

const MeetingPage = () => {
  const textEditorRef = useRef<NotesTextEditorHandle>(null)
  const [meetingState, setMeetingState] = useState<MeetingState | null>(null)
  const { loading: pageDetailsLoading, meetingId } = useMeeting()
  const [activeTab, setActiveTab] = useState<'notes' | 'transcript'>('notes')
  const { transcript, loadingTranscript, refetchTranscript } = useMeetingTranscript()

  const haveTranscript = transcript && transcript.length > 0 ? true : false

  useEffect(() => {
    if (loadingTranscript || !transcript) return

    if (haveTranscript) {
      setMeetingState('post')
    } else {
      setMeetingState('pre')
    }
  }, [loadingTranscript, transcript, haveTranscript])

  useEffect(() => {
    setMeetingState(null)
    refetchTranscript()
    setActiveTab('notes')
  }, [refetchTranscript, meetingId])

  if (pageDetailsLoading || loadingTranscript || !meetingState) {
    return <MeetingSkeleton withPadding />
  }

  return (
    <Box height="full" flexDirection="column" style={{ overflow: 'hidden' }}>
      <Box flexDirection="row" flexGrow style={{ minHeight: '0', overflow: 'hidden' }}>
        <Box flexGrow style={{ minHeight: '0', overflow: 'hidden' }}>
          {haveTranscript && (
            <Box
              paddingTop="s8"
              flexDirection="row"
              justifyContent="spaceBetween"
              alignItems="center"
            >
              <Box width="full">
                <Tabs
                  activeTabId={activeTab}
                  tabs={[
                    {
                      id: 'notes',
                      label: i18n.t('meetings.meeting.notes.title'),
                      onClick: () => setActiveTab('notes'),
                    },
                    {
                      index: true,
                      id: 'transcript',
                      label: i18n.t('meetings.meeting.transcript.title'),
                      onClick: () => setActiveTab('transcript'),
                    },
                  ]}
                />
              </Box>
            </Box>
          )}
          <Box
            height="full"
            overflowY="hidden"
            width="full"
            minHeight="s0"
            flexDirection="row"
            justifyContent="center"
          >
            <Box
              height="full"
              overflowY="hidden"
              width="full"
              minHeight="s0"
              position="relative"
              flexDirection="column"
            >
              <Box style={{ display: activeTab === 'notes' ? 'flex' : 'none' }} height="full">
                <MeetingNotes
                  key={meetingId}
                  textEditorRef={textEditorRef}
                  meetingState={meetingState}
                  haveTranscript={haveTranscript}
                />
              </Box>
              {activeTab === 'transcript' && <PostMeetingTranscript />}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default MeetingPage
